import React, { useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { getMonths } from '../../../features/deletePJP/deletePJPService';
import { Duration } from '../../../features/deletePJP/deletePJPTypes';
import './durationFilter.css';
import { TranslationEnum, usePortalTranslation } from '../../../providers/TranslationProvider';
import dayjs from 'dayjs';
type Props = {
  duration: Duration | null;
  setDuration: (duration: Duration) => void;
};
const DurationFilter: React.FC<Props> = ({ duration, setDuration }: Props) => {
  // const months = getMonths();
  const { translate } = usePortalTranslation();

  // const currentYear = new Date().getFullYear();
  // const years = Array.from({ length: 11 }, (_, index) => (currentYear + 1 - index).toString());
  const today = new Date();
  const currentMonthIndex = today.getMonth();
  const nextMonthIndex = (currentMonthIndex + 1) % 12;
  const months = [
    dayjs(new Date(today.getFullYear(), currentMonthIndex)).format("MMMM"),
    dayjs(new Date(today.getFullYear(), nextMonthIndex)).format("MMMM"),
  ];
  
  // If year might change (e.g., December → next month is January next year)
  debugger;
  const years = [
    today.getFullYear(),
    ...(nextMonthIndex === 0 ? [today.getFullYear() + 1] : []),
  ].map(year => year.toString());
  

  const [selectedMonth, setSelectedMonth] = useState(duration?.month || null);
  const [selectedYear, setSelectedYear] = useState(duration?.year || null);

  const handleApply = () => {
    if (selectedMonth && selectedYear) {
      setDuration({ month: selectedMonth, year: selectedYear });
    }
  };

  return (
    <div className="deletePJP-dateFilter-wrapper">
      {/* select month */}
      <Autocomplete
        className='deletePJP-dateFilter-input'
        options={months}
        onChange={(event, newValue) => setSelectedMonth(newValue || null)}
        renderInput={(params) => <TextField {...params} label={translate(TranslationEnum.delete_pjp,"Select Month")} />}
      />
      {/* select year */}
      <Autocomplete
              className='deletePJP-dateFilter-input'

        options={years}
        onChange={(event, newValue) => setSelectedYear(newValue || null)}
        renderInput={(params) => <TextField {...params} label={translate(TranslationEnum.delete_pjp,"Select Year")} />}
      />
      {/* apply button */}
      <div 
        onClick={handleApply} 
        className='deletePJP-dateFilter-button'
        >
        {translate(TranslationEnum.delete_pjp,"Apply")}
      </div>
    </div>
  );
};

export default DurationFilter;